import { Flex, FlexItem } from 'shared_DEPRECATED/components/Flex';
import Spacer from 'shared_DEPRECATED/components/Spacer';

import { VARIANTS } from 'shared/components/Button';
import ButtonLink from 'shared/components/Button/ButtonLink';
import { Typography } from 'shared/components/Typography';

export const GeneralError = () => (
  <Flex
    alignItems="center"
    justifyContent="center"
    flexDirection="column"
    width="100%"
    height="100%"
  >
    <FlexItem width="23rem">
      <Spacer size="zr zr md">
        <Spacer size="zr zr sm">
          <header>
            <Spacer size="zr zr md">
              <Typography as="div" type="largeHeading" textAlign="center">
                🙈
              </Typography>
            </Spacer>
            <Typography
              as="h1"
              type="heading"
              fontWeight="semibold"
              textAlign="center"
              color="black"
            >
              Something went wrong
            </Typography>
          </header>
        </Spacer>
      </Spacer>
    </FlexItem>
    <FlexItem width="23rem">
      <Spacer size="zr zr lg">
        <Spacer size="zr zr md">
          <Typography as="p" color="gray" type="meta" textAlign="center">
            Sorry, we can't load this page right now. <br />
            Try refreshing the page or come back later.
          </Typography>
        </Spacer>
      </Spacer>
      <Flex justifyContent="center">
        <Spacer size="zr md zr zr">
          <ButtonLink to="/" color={VARIANTS.PRIMARY}>
            Go Home
          </ButtonLink>
        </Spacer>
      </Flex>
    </FlexItem>
  </Flex>
);
